"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var context_1 = require("../../context");
var Button_1 = require("../Button");
var ClientNameAndUid_1 = __importDefault(require("../Client/ClientNameAndUid"));
var Grid_1 = require("../Grid");
var Tabs_1 = require("../Tabs");
var ContactDetailsProfile_1 = __importDefault(require("./Tabs/ContactDetailsProfile"));
var PersonalDetailsProfile_1 = __importDefault(require("./Tabs/PersonalDetailsProfile"));
var MedicalDetailsProfile_1 = __importDefault(require("./Tabs/MedicalDetailsProfile"));
var AddressDetailsProfile_1 = __importDefault(require("./Tabs/AddressDetailsProfile"));
var DisabilitiesDetailsProfile_1 = __importDefault(require("./Tabs/DisabilitiesDetailsProfile"));
var EthnicityDetailsProfile_1 = __importDefault(require("./Tabs/EthnicityDetailsProfile"));
var CommentsProfile_1 = __importDefault(require("./Tabs/CommentsProfile"));
var defaultClientTabs_1 = __importDefault(require("../ClientForm/utils/defaultClientTabs"));
var RestrictionsDetailsProfile_1 = __importDefault(require("./Tabs/RestrictionsDetailsProfile"));
var CarersDetailsProfile_1 = __importDefault(require("./Tabs/CarersDetailsProfile"));
var Spinner_1 = require("../Spinner");
var ClientProfile = function (props) {
    var onTabChange = props.onTabChange, onEditClick = props.onEditClick, appendTabs = props.appendTabs, client = props.client, children = props.children, tabs = props.tabs, isLoadingTabs = props.isLoadingTabs;
    var trans = context_1.useSemantics().trans;
    var _a = react_1.useState([]), combinedTabs = _a[0], setCombinedTabs = _a[1];
    react_1.useEffect(function () {
        var actualTabs = defaultClientTabs_1.default(trans);
        if (appendTabs && tabs) {
            actualTabs.push.apply(actualTabs, tabs);
        }
        else if (tabs) {
            actualTabs = tabs;
        }
        setCombinedTabs(actualTabs);
    }, [tabs, appendTabs]);
    return (react_1.default.createElement("div", { "data-dusk": "client-profile", "data-client-id": client.id, className: "client-profile" },
        react_1.default.createElement(Grid_1.Grid, { gridClassName: "items-center", className: "pb-8" },
            react_1.default.createElement(Grid_1.GridColumn, { width: "flex-grow" },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(ClientNameAndUid_1.default, { name: client.name, uid: client.uid }))),
            react_1.default.createElement(Grid_1.GridColumn, { width: "flex-none" }, onEditClick && (react_1.default.createElement(Button_1.Button, { onClick: onEditClick }, trans('optiiva::labels.edit'))))),
        react_1.default.createElement(Tabs_1.Tabs, { onChange: onTabChange, tabs: combinedTabs },
            react_1.default.createElement(Grid_1.Grid, { size: "lg" },
                react_1.default.createElement(Grid_1.GridColumn, { size: "lg", width: "w-64 border-r-3 border-gray-light" },
                    react_1.default.createElement(Tabs_1.TabList, null),
                    isLoadingTabs ? (react_1.default.createElement("div", { className: "text-center" },
                        react_1.default.createElement(Spinner_1.SpinnerInverted, null))) : (react_1.default.createElement("span", null))),
                react_1.default.createElement(Grid_1.GridColumn, { size: "lg", width: "flex-grow" },
                    react_1.default.createElement(Tabs_1.TabPanels, null,
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.personal" },
                                react_1.default.createElement(PersonalDetailsProfile_1.default, { client: client })),
                            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.contact" },
                                react_1.default.createElement(ContactDetailsProfile_1.default, { client: client })),
                            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.ethnicity" },
                                react_1.default.createElement(EthnicityDetailsProfile_1.default, { client: client })),
                            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.medical" },
                                react_1.default.createElement(MedicalDetailsProfile_1.default, { client: client })),
                            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.address" },
                                react_1.default.createElement(AddressDetailsProfile_1.default, { client: client })),
                            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "disabilities" },
                                react_1.default.createElement(DisabilitiesDetailsProfile_1.default, { client: client })),
                            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "comments" },
                                react_1.default.createElement(CommentsProfile_1.default, { client: client })),
                            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.restrictions" },
                                react_1.default.createElement(RestrictionsDetailsProfile_1.default, { client: client })),
                            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.carers" },
                                react_1.default.createElement(CarersDetailsProfile_1.default, { client: client })),
                            children)))))));
};
exports.default = ClientProfile;
//# sourceMappingURL=ClientProfile.js.map